import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/users',
    name: 'User',
    component: {
      name: 'AdminUser',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'user',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminUserIndex',
        component: () => import('../views/UserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminUserNew',
        component: () => import('../views/UserInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminUserIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminUserShow',
        component: () => import('../views/UserShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminUserIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminUserDetails',
            component: () => import('../views/UserDetails.vue'),
            meta: {
              backRoute: { name: 'AdminUserIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminUserEdit',
            component: () => import('../views/UserInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminUserDetails' },
            },
          },
          {
            path: 'user_roles',
            name: 'AdminUserUserRoles',
            component: () => import('../views/userRole/UserUserRoles.vue'),
            meta: {
              backRoute: { name: 'AdminUserIndex' },
              resource: 'user_role',
            },
          },
          {
            path: 'user_roles/edit',
            name: 'AdminUserRolesEdit',
            component: () => import('../views/userRole/UserRolesInput.vue'),
            meta: {
              action: 'edit',
              customName: 'views.user.roles.edit',
              backRoute: { name: 'AdminUserUserRoles' },
            },
          },
          {
            path: 'dashboard_pages',
            name: 'AdminUserDashboardPages',
            component: () => import('../views/dashboardPage/UserDashboardPages.vue'),
            meta: {
              backRoute: { name: 'AdminUserIndex' },
              resource: 'dashboard_page',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));